<template>
  <div id="new_account" class="complete_content" @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
          />
          <div class="title">
            <h2>メールアドレス更新完了</h2>
          </div>
          <div>
            <ul class="thanks">
              <li>メールアドレスを更新が完了しました。</li>
              <li>引き続き、mm/styleをご利用ください。</li>
            </ul>
          </div>
          <div id="regist_btn">
            <button class="detail_btn6 btn_pos_center" @click="goEdit()">編集画面に戻る</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'

// Module
import Header from '../components/common/DcHeader'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'

export default {
  name: 'UpdateAccountComplete',
  components: {
    'dd-header': Header,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      pageKey: 'accountComplete',
      pageList: [
        {id: 'accountInput', key: 'accountInput', title: 'アカウント情報入力', route: 'UpdateAccountInput'},
        {id: 'accountConfirm', key: 'accountConfirm', title: 'メールアドレス更新確認'},
        {id: 'accountComplete', key: 'accountComplete', title: 'メールアドレス更新完了'}
      ],
      errors: {}
    }
  },
  computed: {
  },
  methods: {
    goEdit: function () {
      this.$router.push({
        name: 'DcMyPage'
      })
    },
    update: function () {
      let payload = {
        userEmail: this.$route.query.email,
        token: this.$route.query.token
      }
      // DBに登録する
      axios.post(DC_URL.USER + '/update-account', payload
      ).then(response => {
        if (response.data.errorMessage) {
          this.errors['email'] = response.data.errorMessage
        } else {
          App.removeLocalStorage(DC_STORAGE_KEY.UPDATE_USER)
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  },
  created () {
    let updFlag = App.getLocalStorage(DC_STORAGE_KEY.UPDATE_USER)
    if (updFlag === true) {
      this.update()
    }
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcUpdateAccountComplete.vue